/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.personalization.rpc.RequestsRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const sendSkuUpgradeNotificationRpc = {
  serviceName: 'com.hubspot.personalization.rpc.RequestsRpc',
  rpcName: 'sendSkuUpgradeNotification',
  auth: 'app',
  fingerprint: 'oGpCOxlIz1OOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendTrialRequestNotificationRpc = {
  serviceName: 'com.hubspot.personalization.rpc.RequestsRpc',
  rpcName: 'sendTrialRequestNotification',
  auth: 'app',
  fingerprint: 'oGpCOxlIz1OOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};